import { Component, Input, OnInit } from '@angular/core';
import { Movie } from 'app/shared/models/class/movie/movie';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { MovieService } from 'app/shared/services/movie/movie.service';
import { RatingService } from 'app/shared/services/rating/rating.service';
import { AdminRating } from 'app/shared/models/class/rating/admin-rating';
import { UiService } from 'app/shared/services/ui/ui.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'app/components/dialog/dialog-component/dialog.component';

@Component({
  selector: 'app-rate',
  templateUrl: './rate.component.html',
  styleUrls: ['./rate.component.scss']
})
export class RateComponent implements OnInit {

  id!: string;
  faChevronLeft = faChevronLeft;
  movie!: Movie;
  ratings!: number;
  disturbing!: number;
  votes: AdminRating[] = [];

  isLoading = false;

  constructor(
    private movieService: MovieService,
    private ratingService: RatingService,
    private uiService: UiService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.initPage();
  }

  askVote():void{
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '250px',
      data: {
        title: 'Confirmation',
        message: 'Êtes-vous sûr de vouloir voter ?',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.sendVote();
      }
    });
  }

  sendVote(): void {
    this.isLoading = true;
    this.ratingService.vote(this.votes).subscribe({
      next: () => {
        this.isLoading = false;
        this.ratingService.ratingSubject.next(1);
        this.votes = [];
        if (this.movie.subMovies) {
          this.votes = this.movie.subMovies.map(sm => new AdminRating(sm.id, 1, 1));
        } else {
          this.votes.push(new AdminRating(this.movie.id, 1, 1));
        }
        this.uiService.showSnackbar("Le vote a été enregistré !", false, 2000);
      }
    });
  }

  valueUpdated(value: { rating: number, disturbing: number, id: string }): void {
    let rate = this.votes.find(v => v.id === value.id);
    if (rate) {
      rate.disturbingRate = value.disturbing;
      rate.rate = value.rating;
    } else {
      const newRate = new AdminRating(value.id, value.rating, value.disturbing);
      this.votes.push(newRate);
    }
  }

  private initPage(): void {
    this.isLoading = true;
    this.id = this.route.snapshot.paramMap.get('id') ?? '';
    this.movieService.getMovie(this.id).subscribe({
      next: movies => {
        if (movies && movies[0]) {
          this.movie = movies[0];
          if (this.movie.subMovies) {
            this.votes = this.movie.subMovies.map(sm => new AdminRating(sm.id, 1, 1));
          } else {
            this.votes.push(new AdminRating(this.movie.id, 1, 1));
          }
        }
        this.isLoading = false;        
      }
    });
  }

}
